module.exports = __webpack_public_path__ + "static/media/hurricane.40cb2cb4.svg";